import axios from "axios";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import store from "./redux/store";
import { start, stop } from "./utils/progress";

import "./index.css";

// Send cookies with each request
axios.defaults.withCredentials = true;
axios.interceptors.request.use((request) => {
  start();
  return request;
});

axios.interceptors.response.use((response) => {
  stop();
  return response;
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);
